import Cookie from './Cookie';

jQuery(document).ready(function () {
	initAutoSugest();
	openExternalLinksInNewWinodw();
	autoCompleteFormInformationWhenLoggedIn();
	sortTables();
	sortUlLITables();
	responsiveIframes();
});



$(document).ready(function () {
	const SCROLL_KEY = 'keepScrollY';

	function saveScroll() {
		sessionStorage.setItem(SCROLL_KEY, window.scrollY);
	}

	function restoreScroll() {
		const y = sessionStorage.getItem(SCROLL_KEY);
		if (y !== null) {
			window.scrollTo(0, parseInt(y, 10));
			sessionStorage.removeItem(SCROLL_KEY);
		}
	}

	let cookie = new Cookie('pop-up-seen');

	if (cookie.get() !== 'true') {
		window.scrollTo(0, 0);
		$('#popup-msg').modal('show');
	}

	$('.pop-up-button').on('click', function () {
		$('#popup-msg').modal('hide');
		cookie.set(true);
	});

	document.querySelectorAll('.js-tag-filter').forEach(function (select) {
		select.addEventListener('change', function () {
			const params = new URLSearchParams(window.location.search);
			const group = this.dataset.group;

			[...params.keys()].forEach(function (key) {
				if (key.startsWith('tags[' + group + ']')) {
					params.delete(key);
				}
			});

			if (this.value) {
				params.set('tags[' + group + '][' + this.value + ']', '1');
			}

			params.delete('page');

			saveScroll();
			window.location.search = params.toString();
		});
	});

	// zoekformulier: scrollpositie onthouden bij submit
	document.querySelectorAll('.js-keep-scroll').forEach(function (form) {
		form.addEventListener('submit', saveScroll);
	});

	document.querySelectorAll('.js-tag-clear').forEach(function (btn) {
		btn.addEventListener('click', function () {
			const select = document.getElementById('tags_' + this.dataset.group);
			select.value = '';
			select.dispatchEvent(new Event('change'));
		});
	});

	// scrollpositie herstellen na de reload
	if (document.readyState === 'complete') {
		restoreScroll();
	} else {
		window.addEventListener('load', restoreScroll);
	}
});
function responsiveIframes() {

	$('iframe').each(function(){
		var $iframe = $(this);
		var $newDiv = $('<div class="embed-responsive embed-responsive-16by9"></div>');
		$iframe.replaceWith($newDiv);
		$newDiv.append($iframe);
		$iframe.addClass('embed-responsive-item');
	});
}
function sortTables() {
	$('.table').on('click', 'th', function(){
		var $th = $(this);
		var $table = $(this).closest('.table');
		var isSortedAsc = $th.hasClass('sorted-asc');
		var $ths = $table.find('th');
		var index = $ths.index(this);
		// debugger;
		$table.find('th').removeClass('sorted-asc sorted-desc');

		var rows = $table.find('tbody > tr').detach().get();
		if( ! isSortedAsc ){
			$th.addClass('sorted-asc');
			rows.sort(function(a,b){
				var text1 = $(a).children().eq(index).text();
				var text2 = $(b).children().eq(index).text();
				if (text1 > text2) return 1;
				if (text1 < text2) return -1;
				return 0;
			});
		} else {
			$th.addClass('sorted-desc');
			rows.sort(function(a,b){
				var text1 = $(a).children().eq(index).text();
				var text2 = $(b).children().eq(index).text();
				if (text1 < text2) return 1;
				if (text1 > text2) return -1;
				return 0;
			});
		}

		$.each(rows, function(index, row) {
			$table.children('tbody').append(row);
		});
	});
}

function sortUlLITables() {
	$('.list-4-columns,.list-3-columns, .list-5-columns').on('click', '.header div', function(e){
		e.preventDefault();
		var $heading = $(this);
		var $table = $(this).closest('.list-4-columns,.list-3-columns,.list-5-columns');
		$table.addClass('loading');

		var isSortedAsc = $heading.hasClass('sorted-asc');
		var $headings = $table.find('.header div');
		var index = $headings.index(this);
		// debugger;
		$headings.removeClass('sorted-asc sorted-desc');

		setTimeout(()=>{
			var rows = $table.find('.item').detach().get();
			if( ! isSortedAsc ){
				$heading.addClass('sorted-asc');
				rows.sort(function(a,b){
					var text1 = $(a).children().eq(index).text();
					var text2 = $(b).children().eq(index).text();
					if (text1 > text2) return 1;
					if (text1 < text2) return -1;
					return 0;
				});
			} else {
				$heading.addClass('sorted-desc');
				rows.sort(function(a,b){
					var text1 = $(a).children().eq(index).text();
					var text2 = $(b).children().eq(index).text();
					if (text1 < text2) return 1;
					if (text1 > text2) return -1;
					return 0;
				});
			}
			$table.append(rows);
			$table.removeClass('loading');
		},1); //first repaint for loading indicator
	});
}

function initAutoSugest() {
	var searchTS;
	jQuery('header .search:not(.no-autosuggest) input[name="q"]').on('keyup', function () {
		search = jQuery(this);
		clearTimeout(searchTS);
		if (search.val() == '') {
			jQuery('#searchaugosuggest').hide();
		}
		searchTS = setTimeout(function () {
			if (search.val().length > 1) {
				jQuery.ajax('/zoeken?q=' + search.val()).done(function (result) {
					result = jQuery.parseJSON(result);
					var html = '';
					if (result) {
						var html = '<ul>';
						jQuery.each(result, function (key, value) {
							html += '<li><a href="' + value.url + '">' + value.name + '</a></li>';
						});
						html += '</ul>';
					}
					jQuery('#searchaugosuggest').show().html(html);
				});
			}
		}, 400);
	});
}

function openExternalLinksInNewWinodw() {
	var all_links = document.querySelectorAll('a');
	for (var i = 0; i < all_links.length; i++) {
		var a = all_links[i];
		if (a.hostname != location.hostname) {
			a.rel = 'noopener';
			a.target = '_blank';
		}
	}
}

function autoCompleteFormInformationWhenLoggedIn() {
	if (!App.user) return;
	$('.form-prevent-multiple-submit').each(function () {
		$(this).find('[name^="naam"]').val(getFullName());
		$(this).find('[type="email"]').val(App.user.EmailAddress);
	});
}

function getFullName() {
	return App.user.Voorletters + (App.user.Tussenvoegsel ? ' ' + App.user.Tussenvoegsel : '') + ' ' + App.user.Naam;
}
